import * as React from 'react';
/**
 *
 * Original name: star
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=8355%3A0
 *
 */
export const StarPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M57.018 25.755 40.282 23.44 32 8.538l-8.282 14.901-16.736 2.316 11.9 12.691L16.46 54.9 32 46.794 47.54 54.9l-2.427-16.459 11.905-12.686ZM32 42.394 21.54 47.85l1.573-10.666-8.1-8.622 11.265-1.559L32 16.713l5.718 10.285 11.265 1.56-8.1 8.62 1.573 10.667L32 42.394Z", fill: "currentColor" })));
